import * as Constants from '../constants/DishConstants';

export const setDishData = (payload:any) => {
    return {
        type:Constants.SET_DISH_DATA,
        data:payload 
    }
}

export const setMiscDishData = (payload:any) => {
    return {
        type:Constants.SET_MISC_DISH_DATA,
        data:payload
    }
}

export const clearDishData = (payload:any) => {
    return {
        type:Constants.CLEAR_DISH_DATA,
        data:payload
    }
}

export const changeDishQuantity = (payload:any) => {
    return {
        type:Constants.CHANGE_DISH_QUANTITY,
        data:payload
    }
}

export const changeIngredientQuantity = (payload:any) => {
    return {
        type:Constants.CHANGE_INGREDIENT_QUANTITY,
        data:payload
    }
}

export const setUserHasAllowedAllergic = (payload:any) => {
    return {
        type:Constants.SET_USER_HAS_ALLOWED_ALLERGIC,
        data:payload
    }
}